// action
import {
    SAVE_SAMPLE_CONTAINER_TEST_MAP,
    SAVE_SAMPLE_CONTAINER_TEST_MAP_FAIL,
    SAVE_SAMPLE_CONTAINER_TEST_MAP_SUCCESS,
    SAVE_SAMPLE_CONTAINER_TEST_MAP_RESET
} from '../action/saveSampleContainerTestMapAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SAVE_SAMPLE_CONTAINER_TEST_MAP:
            return {
                ...state,
                apiState: "loading"
            }
        case SAVE_SAMPLE_CONTAINER_TEST_MAP_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case SAVE_SAMPLE_CONTAINER_TEST_MAP_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case SAVE_SAMPLE_CONTAINER_TEST_MAP_RESET:
            return initialState
        default:
            return state
    }
}